import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import ArrowForwardIosIcon from 'components/material-symbol/icons/ArrowForwardIos'
import Button from '@material-ui/core/Button'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Tabs, Tab } from 'components/tabs'
import useStyles from './styles'
import ContactsTab from './contacts-tab'

const StudentLeadTabs = ({ tabValue, handleTabChange, className }) => (
  <Tabs
    value={tabValue}
    onChange={handleTabChange}
    insetLabels={false}
    className={className}
  >
    <Tab value="students" label="Students" />
    <Tab value="leads" label="Leads" />
  </Tabs>
)

const SelectContactsModal = ({
  contacts,
  addContact,
  setContacts,
  inquiries,
  students,
  setOpen,
  setStep,
}) => {
  const [error, setError] = useState(null)
  const [tabValue, setTabValue] = useState('students')
  const styles = useStyles()

  const currentInquiries = tabValue === 'students' ? students : inquiries
  const currentContactIds = currentInquiries.map(({ contact }) => contact.id)
  const selectedOnTabCount = currentContactIds.filter(id =>
    contacts.includes(id),
  ).length
  const allSelected =
    currentContactIds.length > 0 &&
    selectedOnTabCount === currentContactIds.length
  const someSelected =
    selectedOnTabCount > 0 && selectedOnTabCount < currentContactIds.length

  const handleNextStep = () => {
    if (contacts.length) {
      setError(null)
      setStep(1)
    } else {
      setError('Please select at least 1 contact.')
    }
  }

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue)
    setError(null)
  }

  const handleSelectAll = () => {
    setError(null)

    if (allSelected) {
      setContacts(contacts.filter(id => !currentContactIds.includes(id)))
      return
    }

    setContacts([...new Set([...contacts, ...currentContactIds])])
  }

  return (
    <>
      <DialogTitle disableTypography classes={{ root: styles.titleRoot }}>
        <Typography component="h2" variant="inherit" className={styles.title}>
          Select Contacts
        </Typography>
      </DialogTitle>
      <DialogContent classes={{ root: styles.content }}>
        <StudentLeadTabs
          tabValue={tabValue}
          handleTabChange={handleTabChange}
          className={styles.tabs}
        />
        {error && !contacts.length ? (
          <Typography className={styles.errorText}>{error}</Typography>
        ) : null}
        {currentInquiries.length > 0 ? (
          <>
            <List disablePadding>
              <ListItem
                button
                className={styles.selectAllRow}
                onClick={handleSelectAll}
              >
                <Checkbox
                  edge="start"
                  color="primary"
                  checked={allSelected}
                  indeterminate={someSelected}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-label': 'Select all' }}
                />
                <Box pl={2}>
                  <ListItemText
                    primary={
                      contacts.length > 0
                        ? `${contacts.length} selected`
                        : 'Select all'
                    }
                  />
                </Box>
              </ListItem>
            </List>
            <Divider className={styles.listDivider} />
          </>
        ) : null}
        <ContactsTab
          inquiries={currentInquiries}
          contacts={contacts}
          addContact={addContact}
          type={tabValue}
        />
      </DialogContent>
      <DialogActions classes={{ root: styles.actions }}>
        <Button onClick={() => setOpen(false)} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleNextStep}
          color="primary"
          variant="contained"
          endIcon={<ArrowForwardIosIcon fontSize="small" />}
        >
          Next
        </Button>
      </DialogActions>
    </>
  )
}

SelectContactsModal.propTypes = {
  contacts: PropTypes.array,
  addContact: PropTypes.func,
  setContacts: PropTypes.func,
  inquiries: PropTypes.array,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  setStep: PropTypes.func,
}

export default SelectContactsModal
